import { useSearchParams } from "react-router-dom"
import { useExtEvents } from "./queries"
import { SESSION_PARAM } from "."
import { useMemberId } from "pages/member"
import { Drawer, List } from "antd"
import moment from "moment"
import { useTranslation } from "react-i18next"

interface IDisplayEventsProps {
  onClose: () => void
  isOpen: boolean
  activityId: string
  activityName: string
}

const DisplayEvents: React.FC<IDisplayEventsProps> = ({
  onClose,
  isOpen,
  activityId,
  activityName,
}) => {
  const [searchParams] = useSearchParams()
  const memberId = useMemberId()
  const { t } = useTranslation()

  const events = useExtEvents(
    {
      filter: {
        session: { values: [searchParams.get(SESSION_PARAM)], operator: "in" },
        activity: { values: [activityId], operator: "in" },
        status: { values: ["draft", "approved"], operator: "in" },
      },

      check_cart_for_member_id: memberId,
    },
    {
      enabled: !!searchParams.get(SESSION_PARAM),
      select(data) {
        return data.map((e) => ({ ...e, activity_id: activityId! }))
      },
    }
  )

  return (
    <Drawer
      title={activityName}
      placement="right"
      width={500}
      onClose={onClose}
      open={isOpen}
    >
        <List
          itemLayout="horizontal"
          dataSource={events.data}
          loading={events.isLoading}
          locale={{emptyText: t("global.no_data_display")}}
          renderItem={(item) => (
            <List.Item>
              {moment(item.start_date).format("dddd DD MMMM YYYY")}{" : "}
              {`${item.start_hour}h ${t("global.to").toLowerCase()} ${item.end_hour}h`}
            </List.Item>
          )}
        />
    </Drawer>
  )
}

export default DisplayEvents
